import { Vue, Component, Prop } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { UserGetters } from '@/store/modules/user/types'
import { userModule } from '@/store/namespaces'
import { ProjectID } from '@/types/platform'
import { RootGetters } from '@/store/types'
import { setControlBarDataInUrl } from '../../lib/url-search-data'
import { setControlBarDataInStorage } from '../../lib/user-storage'

import type {
  SortFieldItem as ISortFieldItem,
  SortFieldValue as TSortFieldValue,
} from '../../types'

@Component
export default class SortField extends Vue {
  @userModule.Getter
  private readonly getUserId!: UserGetters['getUserId']

  @Getter('getPlatform') private readonly platform!: RootGetters['getPlatform']

  @Prop({ type: String })
  private readonly essenceStorage?: string

  @Prop({ type: Boolean, default: false }) private readonly saveInUrl!: boolean

  @Prop({ type: [String, Number] }) private readonly value?: TSortFieldValue

  @Prop({ type: Array, required: true })
  private readonly items!: ISortFieldItem[]

  private onChangeValue(value: TSortFieldValue) {
    this.$emit('change:value', value)
    this.$emit('submit')

    this.saveFiltersInUrl(value)
    this.saveFiltersInStorage(value)
  }

  private saveFiltersInUrl(value: TSortFieldValue) {
    if (!this.saveInUrl) {
      return
    }

    setControlBarDataInUrl({
      sortValue: value,
    })
  }

  private saveFiltersInStorage(value: TSortFieldValue) {
    if (!this.essenceStorage) {
      return
    }

    setControlBarDataInStorage({
      essence: this.essenceStorage,
      sortFieldValue: value,
      platform: this.platform,
      userId: this.getUserId(ProjectID[this.platform]),
    })
  }
}
